import { render, staticRenderFns } from "./AddBlog.vue?vue&type=template&id=6a461c27&scoped=true"
import script from "./AddBlog.vue?vue&type=script&lang=js"
export * from "./AddBlog.vue?vue&type=script&lang=js"
import style0 from "./AddBlog.vue?vue&type=style&index=0&id=6a461c27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a461c27",
  null
  
)

export default component.exports